// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
var CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
var ReactDatepicker = require("../../../uikit/atoms/Datepicker/ReactDatepicker.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var Options__LeaseLength = require("../../../reason/common/types/options/Options__LeaseLength.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardRelayKeyFactsRentalData_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsRentalData_draft_graphql.bs.js");
var PropertyWizardFormRelay__Validators__KeyFacts__PropertyType = require("./PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.bs.js");

var convertFragment = PropertyWizardRelayKeyFactsRentalData_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsRentalData_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsRentalData_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsRentalData_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsRentalData_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_leaseLengthValue_decode = PropertyWizardRelayKeyFactsRentalData_draft_graphql.Utils.leaseLengthValue_decode;

var DraftFragment_leaseLengthValue_fromString = PropertyWizardRelayKeyFactsRentalData_draft_graphql.Utils.leaseLengthValue_fromString;

var DraftFragment = {
  leaseLengthValue_decode: DraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: DraftFragment_leaseLengthValue_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__RentalData(props) {
  var stepHasBeenTouched = props.stepHasBeenTouched;
  var match = PropertyWizardFormRelay.Context.use();
  var draft = use(props.draft);
  var draftProperty = draft.draftProperty;
  var leaseLengthOption = Core__Option.map(draftProperty.leaseLength, (function (v) {
          return Options__LeaseLength.make(v);
        }));
  var leaseLength = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (current, value) {
            var newrecord = Caml_obj.obj_dup(current);
            newrecord.leaseLength = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draftProperty.leaseLength, PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.LeaseLength.useIsValid(draft.fragmentRefs));
  var availableFrom = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (current, value) {
            var newrecord = Caml_obj.obj_dup(current);
            newrecord.availableFrom = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draftProperty.availableFrom, PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.AvailableFrom.useIsValid(draft.fragmentRefs));
  var match$1 = leaseLength.status;
  var tmp;
  var tmp$1 = match.mode;
  tmp = typeof tmp$1 !== "object" ? Caml_option.some(CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone))) : undefined;
  return JsxRuntime.jsx(FormV5.FormSection.make, {
              children: JsxRuntime.jsxs(CssGrid.Grid, {
                    children: [
                      JsxRuntime.jsxs(CssGrid.Cell, {
                            width: 12,
                            widthMd: 4,
                            children: [
                              JsxRuntime.jsx(Form__Label.make, {
                                    labelText: "Length of Lease"
                                  }),
                              JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
                                    getOptionLabel: Options__LeaseLength.getOptionLabel,
                                    getOptionValue: Options__LeaseLength.getOptionValue,
                                    onBlur: (function (param) {
                                        leaseLength.onBlur();
                                      }),
                                    onChange: (function (value) {
                                        leaseLength.onChange(value !== undefined ? value.value : undefined);
                                      }),
                                    options: Options__LeaseLength.defaultOptions,
                                    value: leaseLengthOption,
                                    status: match$1 !== undefined ? (
                                        match$1 === "ok" ? "Success" : "Failure"
                                      ) : "Neutral"
                                  }),
                              JsxRuntime.jsx(Form__Components.FieldError.make, {
                                    valid: leaseLength.valid
                                  })
                            ]
                          }),
                      JsxRuntime.jsxs(CssGrid.Cell, {
                            width: 12,
                            widthMd: 4,
                            children: [
                              JsxRuntime.jsx(Form__Label.make, {
                                    labelText: "Available From"
                                  }),
                              JsxRuntime.jsx(ReactDatepicker.make, {
                                    onChange: (function (value) {
                                        availableFrom.onChange(value);
                                      }),
                                    selected: availableFrom.value,
                                    minDate: tmp,
                                    status: availableFrom.status
                                  }),
                              JsxRuntime.jsx(Form__Components.FieldError.make, {
                                    valid: availableFrom.valid
                                  })
                            ]
                          })
                    ]
                  })
            });
}

var Components;

var FormSection;

var Grid;

var Cell;

var Validators;

var FormUtils;

var make = PropertyWizardRelay__KeyFacts__RentalData;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Grid = Grid;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* FormV5 Not a pure module */
